import React, { ComponentProps } from 'react';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { TableOfContentsForm } from '../partials/TableOfContentsForm';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';

type TableOfContentsEditProps = {
  form: TableOfContentsForm['form'];
};

function TableOfContentsEdit({ form }: TableOfContentsEditProps) {
  const { refresh } = useRefreshBlock();
  return <TableOfContentsForm form={form} refreshBlock={refresh} />;
}

export const TableOfContentsEditView = asFetchableView(TableOfContentsEdit);
export type TableOfContentsEditView = ComponentProps<typeof TableOfContentsEditView>;
